import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css'; // Make sure this file exists for styling

const Header: React.FC = () => {
    return (
        <header className="header">
            <div className="header-content">
                <Link to="/">
                    <img
                        src="/logos/cropped_logo_full_black.png"
                        alt="Colin Skofield Violins"
                        className="header-image"
                        style={{ width: '100%', display: 'block' }}
                    />
                </Link>
                <nav className="header-nav">
                    <ul className="header-nav-list">
                        <li><Link to="/services">Services</Link></li>
                        <li><Link to="/forsale">For Sale</Link></li>
                        <li><Link to="/about">About Me</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;